export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const SET_MODAL = 'SET_MODAL'
export const NOTIFY = 'NOTIFY'
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION'
